import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptop, faDollarSign, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import Price from 'Components/Utility/Price/Price';

function BundleMixedPoints({
  maxPrice,
  validDrm,
  productTypes,
  siteTheme,
  productId,
}) {
  const killerBundle30CIS = '66462473d64517743e6204bf';
  const killerBundle30JAPAN = '6646274ec67a274f87ef437b';
  const killerBundle30LATAM = '664623adb51c66694bb279c8';
  const killerBundle30ROW = '6646137fd64517743e61ed48';
  const killerBundle30CNKRVN = '664627ee6f073d4fff087dd9';

  const killerBundle30 = [
    killerBundle30CIS, // CIS
    killerBundle30JAPAN, // JAPAN
    killerBundle30LATAM, // LATAM
    killerBundle30ROW, // ROW
    killerBundle30CNKRVN, // CN/KR/VN
  ];
  const isKillerBundle30 = killerBundle30.includes(productId);

  return (
    <div className="BundlePoints BundlePoints--mixed">
      <div className="BundlePoints__points container">
        <div className="BundlePoints__point">
          <div className="BundlePoints__dollarIcon BundlePoints__icon">
            <FontAwesomeIcon icon={faDollarSign} />
          </div>
          <div className="BundlePoints__pointText">
            <FormattedMessage
              id="mixed-bar.worth_of_products"
              defaultMessage="Get {price} worth of products"
              values={{
                price: <Price
                  price={maxPrice}
                />,
              }}
            />
          </div>
        </div>

        {!isKillerBundle30 &&
          <div className="BundlePoints__point">
            <div className="BundlePoints__gameIcon BundlePoints__icon">
              <FontAwesomeIcon icon={faLaptop} />
            </div>
            <div className="BundlePoints__pointText">
              {productTypes.total.game &&
                <FormattedMessage
                  id="mixed-bar.games_plural"
                  defaultMessage="{totalGames, plural, one {# game} other {# games}} {check}"
                  values={{
                    totalGames: productTypes.total.game,
                    check: productTypes.total.dlc || productTypes.total.software || productTypes.total.audio || productTypes.total.comic ? ' + ' : '',
                  }}
                />
              }
              {productTypes.total.dlc &&
                <FormattedMessage
                  id="mixed-bar.dlc"
                  defaultMessage="{totalDlc} DLC {check}"
                  values={{
                    totalDlc: productTypes.total.dlc,
                    check: productTypes.total.software || productTypes.total.audio || productTypes.total.comic ? ' + ' : '',
                  }}
                />
              }
              {productTypes.total.software &&
                <FormattedMessage
                  id="mixed-bar.software"
                  defaultMessage="{totalSoftware} software {check}"
                  values={{
                    totalSoftware: productTypes.total.software,
                    check: (productTypes.total.audio || productTypes.total.comic) ? ' + ' : '',
                  }}
                />
              }
              {productTypes.total.audio &&
                <FormattedMessage
                  id="mixed-bar.audio_plural"
                  defaultMessage="{totalAudio, plural, one {# soundtrack} other {# soundtracks}} {check}"
                  values={{
                    totalAudio: productTypes.total.audio,
                    check: productTypes.total.comic ? ' + ' : '',
                  }}
                />
              }
              {productTypes.total.comic &&
                <FormattedMessage
                  id="mixed-bar.comic"
                  defaultMessage="{totalComic} comics"
                  values={{ totalComic: productTypes.total.comic }}
                />
              }
            </div>
          </div>
        }

        {(
          productId === killerBundle30ROW ||
          productId === killerBundle30LATAM ||
          productId === killerBundle30CIS
        ) &&
          <div className="BundlePoints__point">
            <div className="BundlePoints__gameIcon BundlePoints__icon">
              <FontAwesomeIcon icon={faLaptop} />
            </div>
            <div className="BundlePoints__pointText">
              <FormattedMessage
                id="mixed-bar.killer-bundle-30.row"
                defaultMessage="33 games + 1 DLC"
              />
            </div>
          </div>
        }

        {(
          productId === killerBundle30JAPAN ||
          productId === killerBundle30CNKRVN
        ) &&
          <div className="BundlePoints__point">
            <div className="BundlePoints__gameIcon BundlePoints__icon">
              <FontAwesomeIcon icon={faLaptop} />
            </div>
            <div className="BundlePoints__pointText">
              <FormattedMessage
                id="mixed-bar.killer-bundle-30.other"
                defaultMessage="31 games + 1 DLC"
              />
            </div>
          </div>
        }

        {validDrm.length === 1 &&
          <div className="BundlePoints__point">
            {validDrm[0] !== 'steam' &&
              <div className="BundlePoints__icon">
                <FontAwesomeIcon icon={faCircleCheck} />
              </div>
            }
            {validDrm[0] === 'steam' &&
              <div className="BundlePoints__steamIcon BundlePoints__icon">
                {siteTheme === 'dark' &&
                  <img src="https://cdn.fanatical.com/production/icons/drm/light/steam-icon.svg" alt="Steam" loading="lazy" />
                }
                {siteTheme === 'light' &&
                  <img src="https://cdn.fanatical.com/production/icons/drm/dark/steam-icon-grey-13.svg" alt="Steam" loading="lazy" />
                }
              </div>
            }
            <div className="BundlePoints__pointText">
              <FormattedMessage
                id="mixed-bar.redeem"
                defaultMessage="Redeem keys on {validDrm} "
                values={{
                  validDrm: <span>{validDrm[0]}</span>,
                }}
              />
            </div>
          </div>
        }
      </div>
    </div>
  );
}

BundleMixedPoints.propTypes = {
  maxPrice: PropTypes.shape({}),
  validDrm: PropTypes.arrayOf(PropTypes.string),
  productTypes: PropTypes.shape({}),
  siteTheme: PropTypes.string,
  productId: PropTypes.string,
};

BundleMixedPoints.defaultProps = {
  maxPrice: {},
  validDrm: [],
  productTypes: {},
  siteTheme: 'dark',
  productId: '',
};


const mapStateToProps = ({
  siteTheme,
}) => ({
  siteTheme,
});

export default connect(mapStateToProps)(BundleMixedPoints);
